import * as Styles from "@universityofmaryland/web-styles-library";
import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import { FeedStateEvent } from "./_types.js";
function createPaginationElement(config) {
  const { callback, isLazyLoad, isThemeDark, totalEntries, offset } = config;
  if (!isLazyLoad) return;
  if (!totalEntries) return;
  if (!offset) return;
  if (!callback) return;
  if (offset >= totalEntries) return;
  const button = document.createElement("button");
  button.textContent = "Load more";
  button.addEventListener("click", () => {
    callback();
    button.dispatchEvent(
      new CustomEvent(FeedStateEvent.PAGINATION_LOADED, {
        bubbles: true,
        detail: {
          offset,
          totalEntries,
          timestamp: Date.now()
        }
      })
    );
  });
  const buttonStyle = isThemeDark ? Styles.element.action.outline.white : Styles.element.action.outline.normal;
  const ctaButton = new ElementBuilder(button).styled(buttonStyle).build();
  return new ElementBuilder().styled(Styles.layout.alignment.block.center).withChild(ctaButton).withStyles({
    element: {
      marginTop: `${Styles.token.spacing.lg}`
    }
  }).build();
}
class PaginationState {
  constructor(config) {
    this.container = null;
    this.config = config;
    this.model = createPaginationElement(config);
  }
  /**
   * Render the pagination button if applicable
   * @returns ElementModel if rendered, undefined otherwise
   */
  render(container) {
    if (this.model) {
      this.container = container;
      container.appendChild(this.model.element);
    }
    return this.model;
  }
  /**
   * Remove the pagination button from DOM
   */
  remove() {
    if (this.model && this.model.element.parentNode) {
      this.model.element.remove();
    }
  }
  /**
   * Update pagination state with new offset and total
   * Re-creates button if needed
   */
  updateState(offset, totalEntries) {
    this.config.offset = offset;
    this.config.totalEntries = totalEntries;
    this.remove();
    this.model = createPaginationElement(this.config);
    if (this.container && this.model) {
      this.container.appendChild(this.model.element);
    }
  }
  /**
   * Check if more items are available to load
   */
  hasMore() {
    const { offset, totalEntries } = this.config;
    return !!(totalEntries && offset < totalEntries);
  }
  /**
   * Cleanup and remove pagination
   */
  destroy() {
    this.remove();
    this.container = null;
  }
  /**
   * Get the pagination element if it exists
   */
  get element() {
    return this.model?.element;
  }
  /**
   * Get the pagination styles if element exists
   */
  get styles() {
    return this.model?.styles;
  }
}
export {
  PaginationState,
  createPaginationElement
};
//# sourceMappingURL=pagination.js.map
